export function isQuoteService(service) {
  if (!service) return false;
  if (service.type === 'quote') return true;

  const model = `${service.PricingModel || service.pricingModel || ''}`.toLowerCase().trim();
  return model === 'sur devis' || model === 'quote';
}

export function isFixedPriceService(service) {
  if (!service) return false;
  const model = `${service.PricingModel || service.pricingModel || ''}`.toLowerCase().trim();
  return model === 'prix fixe' || model === 'fixed';
}

export function getCustomerInfoStepSubmitLabel(service) {
  return isQuoteService(service) ? 'Demander un devis' : 'Continuer';
}

export function getPaymentStepLabel(service) {
  return isQuoteService(service) ? 'Devis' : 'Paiement';
}
